<template>
  <v-container fluid class="city-add-page mt-3 mx-1">
    <v-row>
      <v-col cols="12">
        <v-stepper v-model="step" class="transparent elevation-0">
          <v-card class="mb-5">
            <v-stepper-header >
              <v-stepper-step :complete="step > 1" step="1">City</v-stepper-step>
              <v-divider></v-divider>
            </v-stepper-header>
          </v-card>

          <v-card>
            <v-stepper-items>
              <v-stepper-content step="1">
                <v-card>
                  <v-row justify="center">
                    <v-col cols="12" md="6">
                      <v-form>
                        <p class="text-h5">New City</p>
                        <v-text-field
                          class="mb-4"
                          v-model="city.citycode"
                          v-bind:error="errorindex == 0"
                          outlined
                          dense
                          placeholder="City Code"
                          persistent-hint
                          single-line hint="Enter the city Code">
                        </v-text-field>
                        <v-text-field
                          class="mb-4"
                          v-model="city.cityname"
                          v-bind:error="errorindex == 1"
                          outlined
                          dense
                          placeholder="City Name"
                          persistent-hint
                          single-line hint="Enter the city name">
                        </v-text-field>
                        <v-select
                          class="mb-4"
                          :items=citytype
                          v-model="city.citytype"
                          v-bind:error="errorindex == 2"
                          outlined
                          dense
                          placeholder="Type"
                          persistent-hint
                          single-line hint="Please choose the city type">
                        </v-select>
                          <v-select
                          class="mb-4"
                          :items="countries.map(x => {
                            return {text: x.countryname, value: x._id};
                          })"
                          v-model="city.countryid"
                          v-bind:error="errorindex == 3"
                          outlined
                          dense
                          placeholder="Country"
                          persistent-hint
                          single-line hint="Please choose the country">
                        </v-select>
                          <v-switch
                            v-model="city.citystatus"
                            color="primary"
                            v-bind:label="city.citystatus"
                            value="Active"
                          ></v-switch>
                        <div class="d-flex justify-end">

                        </div>
                        <div class="d-flex justify-center">
                        <v-btn
                            to="/city/list"
                            replace
                            outlined
                            color="primary"
                        >
                          Cancel
                        </v-btn>
                        <v-spacer></v-spacer>
                          <v-btn
                            :loading="isReceiving"
                            class="button-shadow"
                            color="primary"
                            @click="insertCity()">
                            Save
                          </v-btn>
                      </div>

                      </v-form>
                    </v-col>
                  </v-row>
                </v-card>
              </v-stepper-content>
            </v-stepper-items>
          </v-card>

        </v-stepper>
      </v-col>
    </v-row>
  </v-container>

</template>

<script>
import {mapActions, mapState} from "vuex";
import router from '@/Routes';

export default {
  data () {
    return {
      step: 1,
      city: {
        citystatus: 'Active'
      },
      citytype: ['District', 'City'],
      error: undefined,
      haserror: false,
      errorindex: undefined,
    }
  },

  methods: {
    ...mapActions('Country', ['getCountriesRequest']),
    ...mapActions('City', ['insertCityRequest','getCitiesRequest']),
    checkError(){
      if(!this.city.citycode){
        this.haserrors = true;
        this.errorindex = 0;
        return false;
      }
      if(!this.city.cityname){
        this.haserrors = true;
        this.errorindex = 1;
        return false;
      }
      if(!this.city.citytype){
        this.haserrors = true;
        this.errorindex = 2;
        return false;
      }
            if(!this.city.countryid){
        this.haserrors = true;
        this.errorindex = 3;
        return false;
      }
      this.errorindex = -1;
      this.step = 2;
      return true;
    },
    async insertCity() {
      if(!this.checkError()) return;
      await this.insertCityRequest(this.city);
      router.push('/city/list')
    },
  },
  computed: {
    ...mapState('Country', ['countries']),
    ...mapState('City', ['isReceiving']),
  },
  created () {
    if(this.countries.length==0) this.getCountriesRequest();
  },

}
</script>

<style src="./Add.scss" lang="scss"></style>
